<template>
  <div>
    <label class="flex items-center cursor-pointer">
      <input
        class="hidden peer"
        type="checkbox"
        :checked="isChecked"
        :disabled="disabled"
        :value="value"
        @change="updateInput"
        @click="handleClick"
      >
      <span class="relative flex justify-center w-5 h-5 border rounded bg-surface-elevated border-border-default peer-checked:border-primary peer-checked:bg-primary/10">
        <i class="relative -top-0.5 text-2xl i i-tick" :class="{'text-primary': isChecked, 'text-surface-elevated': !isChecked}" />
      </span>
      <span class="ml-3 leading-none peer-checked:font-semibold">{{ label }}</span>
    </label>
    <ErrorForm :errors="errors" />
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  value: {
    type: [String, Object],
    default: ''
  },
  modelValue: {
    type: [Array, Boolean],
    default: () => []
  },
  label: {
    type: String,
    required: true
  },
  trueValue: {
    type: Boolean,
    default: true
  },
  falseValue: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  errors: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue', 'click'])

// Compare two objects by reference or by their first available unique key (id, slug, value)
function isSameObject(a, b) {
  if (a === b) return true
  const key = 'id' in a ? 'id' : 'slug' in a ? 'slug' : 'value' in a ? 'value' : null
  if (key && a[key] != null && b[key] != null) return a[key] === b[key]
  return JSON.stringify(a) === JSON.stringify(b)
}

// Computed
const isChecked = computed(() => {
  if (Array.isArray(props.modelValue)) {
    if (props.value && typeof props.value === 'object') {
      return props.modelValue.some(
        item => item && typeof item === 'object'
          ? isSameObject(item, props.value)
          : item === props.value
      )
    }
    return props.modelValue.includes(props.value)
  }
  // Note that `true-value` and `false-value` are camelCase in the JS
  return props.modelValue === props.trueValue
})

// Methods
const updateInput = (event) => {
  const isChecked = event.target.checked
  if (Array.isArray(props.modelValue)) {
    const newValue = [...props.modelValue]
    if (isChecked) {
      newValue.push(props.value)
    } else {
      const idx = props.value && typeof props.value === 'object'
        ? newValue.findIndex(item => item && typeof item === 'object' && isSameObject(item, props.value))
        : newValue.indexOf(props.value)
      if (idx !== -1) {
        newValue.splice(idx, 1)
      }
    }
    emit('update:modelValue', newValue)
  } else {
    emit('update:modelValue', isChecked ? props.trueValue : props.falseValue)
  }
}

const handleClick = (event) => {
  emit('click', event)
}
</script>
